import { useState } from 'react';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';

export const NEW_WORKFLOW_TEST_IDS = {
  ID: 'new-workflow-modal',
  WRAPPER: 'new-workflow-modal-wrapper',
  INPUT: 'new-workflow-name-input',
  BUTTON: 'new-workflow-create-button',
};

const DISPLAY_TEXT = {
  MODAL_TITLE: 'New journey',
  LABEL: 'Journey name',
  CREATE: 'Create and link',
};

interface CreateWorkflowModalProps {
  onClose: () => void;
  onCreate: (wf: string) => void;
}

export const CreateWorkflowModal = ({ onClose, onCreate }: CreateWorkflowModalProps) => {
  const [workflowValue, setWorkflowValue] = useState('');

  const handleConfirm = () => onCreate(workflowValue);

  return (
    <Modal
      data-test={NEW_WORKFLOW_TEST_IDS.WRAPPER}
      id={NEW_WORKFLOW_TEST_IDS.ID}
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>{DISPLAY_TEXT.MODAL_TITLE}</ModalHeader>
      <ModalBody>
        <FormField hasError={false} labelText={DISPLAY_TEXT.LABEL}>
          <InputText
            data-test={NEW_WORKFLOW_TEST_IDS.INPUT}
            id={NEW_WORKFLOW_TEST_IDS.INPUT}
            onChange={(val) => setWorkflowValue(val)}
            value={workflowValue}
            autoFocus
          />
        </FormField>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          data-test={NEW_WORKFLOW_TEST_IDS.BUTTON}
          onClick={handleConfirm}
          isDisabled={!workflowValue}
          size={BUTTON_SIZES.LARGE}
        >
          {DISPLAY_TEXT.CREATE}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
